import httpClient, { handleSuccess, handleError, apiHeader } from './httpClient'
import dayjs from 'dayjs'

export function list() {
  return httpClient.get('portofolio/list').then(handleSuccess).catch(handleError)
}

export function info(portofolioId) {
  const params = new URLSearchParams()
  params.append('portofolio_id', portofolioId)

  return httpClient
    .get('portofolio/info', {
      params
    })
    .then(handleSuccess)
    .catch(handleError)
}

export function listAchievement() {
  return httpClient.get('portofolio/list_achievement').then(handleSuccess).catch(handleError)
}

export async function save(formData) {
  const params = new URLSearchParams()
  if (formData.portofolio_id) {
    params.append('portofolio_id', Number(formData.portofolio_id))
  }
  params.append('title', String(formData.title))
  if (formData.display_name === null) {
    params.append('display_name', '')
  } else {
    params.append('display_name', String(formData.display_name))
  }
  if (formData.introduction === null) {
    params.append('introduction', '')
  } else {
    params.append('introduction', String(formData.introduction))
  }
  params.append('is_show_career', Number(formData.is_show_career))
  if (formData.started_at) {
    params.append('started_at', dayjs(formData.started_at).format('YYYY/MM/DD'))
  }
  if (formData.ended_at) {
    params.append('ended_at', dayjs(formData.ended_at).format('YYYY/MM/DD'))
  }
  params.append('is_stopped', Number(formData.is_stopped))
  params.append('achievement_ids', formData.achievement_ids)
  params.append('profile_items', formData.profile_items)

  return httpClient.post('portofolio/save', params, apiHeader).then(handleSuccess).catch(handleError)
}

export async function _delete(portofolioId) {
  const params = new URLSearchParams()
  params.append('portofolio_id', Number(portofolioId))

  return httpClient.post('portofolio/delete', params, apiHeader).then(handleSuccess).catch(handleError)
}

export async function stop(portofolioId) {
  const params = new URLSearchParams()
  params.append('portofolio_id', Number(portofolioId))

  return httpClient.post('portofolio/stop', params, apiHeader).then(handleSuccess).catch(handleError)
}

export async function regenerateToken(portofolioId) {
  const params = new URLSearchParams()
  params.append('portofolio_id', Number(portofolioId))

  return httpClient.post('portofolio/regenerate_token', params, apiHeader).then(handleSuccess).catch(handleError)
}
